import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import AdminSearch from './AdminSearch';

const BREADCRUMB_MAP: Record<string, string> = {
  '/admin': 'Dashboard',
  '/admin/artworks': 'Artworks',
  '/admin/artworks/new': 'New Artwork',
  '/admin/artists': 'Artists',
  '/admin/artists/new': 'New Artist',
  '/admin/exhibitions': 'Exhibitions',
  '/admin/exhibitions/new': 'New Exhibition',
  '/admin/art-fairs': 'Art Fairs',
  '/admin/art-fairs/new': 'New Art Fair',
  '/admin/team': 'Team',
  '/admin/team/new': 'New Member',
  '/admin/orders': 'Orders',
  '/admin/settings': 'Settings',
};

const AdminHeader: React.FC = () => {
  const location = useLocation();
  const [searchOpen, setSearchOpen] = useState(false);

  const breadcrumb = BREADCRUMB_MAP[location.pathname] || 'Admin';

  // Ctrl+K / Cmd+K shortcut
  useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        setSearchOpen((o) => !o);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <>
      <header className="h-14 border-b border-black/[0.04] bg-white/80 backdrop-blur-xl flex items-center justify-between px-6 sticky top-0 z-[150]">
        <motion.h2
          key={breadcrumb}
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          className="text-[11px] font-bold uppercase tracking-[0.2em] text-black/40"
        >
          {breadcrumb}
        </motion.h2>

        <button
          onClick={() => setSearchOpen(true)}
          className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-black/[0.03] hover:bg-black/[0.06] border border-black/[0.04] transition-all group"
        >
          <Search size={13} className="text-black/25 group-hover:text-black/40" />
          <span className="text-[10px] font-medium text-black/25 group-hover:text-black/40 hidden sm:inline">
            Search...
          </span>
          <kbd className="hidden sm:inline-flex items-center px-1.5 py-0.5 text-[8px] font-bold text-black/15 bg-black/[0.04] rounded-md ml-2">
            Ctrl+K
          </kbd>
        </button>
      </header>

      <AdminSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
};

export default AdminHeader;
